import { useEffect, useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import { Box, Button, Grid, withWidth } from "@material-ui/core";
import {
  FilterBar,
  Container,
  DataGrid,
  Paginate,
  InputText,
  Dialog,
} from "src/components";

import {
  Cancel as CancelIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
} from "@material-ui/icons";

import {
  excluirComplemento,
  pesquisarComplementos,
} from "src/store/actions/complementos";
import * as types from "src/store/types/complementos";
import { Plus as PlusIcon } from "react-feather";
import ModalComplementos from "./ModalComplementos";
import NumberFormat from "react-number-format";

function ComplementosProdutos({ width }) {
  const [complemento, setComplemento] = useState({});
  const [modal, setModal] = useState({ type: "", complemento: {} });

  const dispatch = useDispatch();
  const { filtro, page, perpage, total, complementos, loading } = useSelector(
    (state) => state.complementos
  );

  useEffect(() => {
    dispatch(
      pesquisarComplementos({
        ...filtro,
        page,
        per_page: perpage,
      })
    );
  }, []);

  function limparfiltros() {
    dispatch([
      { type: types.SET_PAGE_COMPLEMENTO, payload: 1 },
      { type: types.SET_FILTRO_COMPLEMENTO, payload: { titulo: "" } },
      pesquisarComplementos({ page: 1, per_page: perpage }),
    ]);
  }

  function handleChangePage(newPage) {
    dispatch([
      { type: types.LOADING_COMPLEMENTO, payload: true },
      { type: types.SET_PAGE_COMPLEMENTO, payload: newPage + 1 },
      pesquisarComplementos({
        ...filtro,
        page: newPage + 1,
        per_page: perpage,
      }),
    ]);
  }

  const handleChangeRowsPerPage = (event) => {
    dispatch([
      { type: types.LOADING_COMPLEMENTO, payload: true },
      {
        type: types.SET_PERPAGE_COMPLEMENTO,
        payload: parseInt(event.target.value, 10),
      },
      pesquisarComplementos({
        ...filtro,
        page: 1,
        per_page: parseInt(event.target.value, 10),
      }),
    ]);
  };

  const handleFiltro = (value) => {
    dispatch({
      type: types.SET_FILTRO_COMPLEMENTO,
      payload: value,
    });
  };

  const handleCloseModal = () => {
    setModal({ type: "" });
    setComplemento({});
  };

  const handleDelete = async () => {
    await excluirComplemento(complemento.id);
    handleCloseModal();
  };

  return (
    <Container title="Complementos">
      <Dialog
        visible={modal.type === "delete"}
        title="Excluir complemento"
        contenttext="Deseja excluir o complemento ?"
        buttons={[
          {
            title: "Excluir",
            icon: <DeleteIcon />,
            onClick: handleDelete,
          },
          {
            title: "Fechar",
            icon: <CancelIcon />,
            onClick: handleCloseModal,
          },
        ]}
      />
      <ModalComplementos
        open={modal.type !== "" && modal.type !== "delete"}
        type={modal.type}
        close={handleCloseModal}
        complemento={modal.complemento}
      />
      <Box display="flex">
        <FilterBar
          fullWidth
          searchFilter={pesquisarComplementos({ ...filtro, per_page: perpage })}
          clearFilter={limparfiltros}
          title="Clique aqui para visualizar as opções de filtro."
        >
          <Grid container spacing={2}>
            <Grid item sm={5}>
              <InputText
                label="Complemento"
                value={filtro.titulo}
                onChange={(e) => handleFiltro({ titulo: e.target.value })}
              />
            </Grid>
          </Grid>
        </FilterBar>
        <Button color="primary" onClick={() => setModal({ type: "insert" })}>
          <PlusIcon />
          Novo
        </Button>
      </Box>
      <PerfectScrollbar>
        <DataGrid
          isLoading={loading}
          columns={[
            {
              title: "ID",
              field: "id",
              width: 30,
              headerStyle: { paddingLeft: 10 },
              cellStyle: { paddingLeft: 10 },
            },
            {
              title: "Complemento",
              field: "titulo",
              width: "auto",
              headerStyle: {},
              cellStyle: {},
            },
            {
              title: "Valor atual",
              render: (rowdata) => (
                <NumberFormat
                  prefix="R$ "
                  displayType="text"
                  decimalSeparator={","}
                  thousandSeparator={"."}
                  fixedDecimalScale={true}
                  value={rowdata.valor_atual || 0}
                  decimalScale={2}
                />
              ),
            },
            {
              title: "Status",
              field: "status",
              lookup: { A: "ATIVO", I: "INATIVO" },
              width: 30,
              headerStyle: {},
              cellStyle: {},
            },
          ]}
          data={complementos}
          actions={[
            {
              icon: () => <EditIcon color="primary" />,
              tooltip: "Visualizar",
              onClick: (event, rowData) => {
                setComplemento(rowData);
                setModal({ type: "update", complemento: rowData });
              },
            },
            {
              icon: () => <DeleteIcon color="primary" />,
              tooltip: "Extrato",
              onClick: (event, rowData) => {
                setComplemento(rowData);
                setModal({ type: "delete" });
              },
            },
          ]}
        />
      </PerfectScrollbar>
      <Paginate
        rowsPerPageOptions={[10, 25, 50]}
        rowsPerPage={perpage}
        count={total}
        page={page - 1}
        onChangePage={(event, newPage) => handleChangePage(newPage)}
        onChangeRowsPerPage={(e) => handleChangeRowsPerPage(e)}
      />
    </Container>
  );
}

export default withWidth()(ComplementosProdutos);
